<!-- Builder Start -->
<div id="{{position}}" class="position-relative"
  [ngStyle]="{'background-image': style,'background-position': backgroundPosition?backgroundPosition:'center left','background-color':'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))'}"
  class="heroBackImageContainer" [ngClass]="activatePadding?'header-padding-top-image':''">
  <div *ngIf="!loading" class="container"
    [ngStyle]="{'background':'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))','justify-content': containerAlignment?containerAlignment:'center'}">
    <header class="app-header-background" [attr.data-aos]="allElementAnimation ? allElementAnimation : null">
      <div class="app-header-section global-max-width">
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start left">
          <div fxFlex="0" fxFlex.lt-sm="100%">
            <div id="demo"></div>
            <div class="app-header-headline" [ngStyle]="{'text-align': textAlignment?textAlignment:'center'}"
              [attr.data-aos]="textAnimation ? textAnimation : null">
              <h1 *ngIf="(title$ | async) as title" [class]="titleSize+' mat-h1'"
                [ngStyle]="{'font-family': titleFontFamily ? titleFontFamilyName : '' ,'font-weight': fontWeight?fontWeight:'500','line-height': lineHeight?lineHeight+'px':'75px'}"
                [innerHtml]="title | safeHtml"> </h1>
              <h2 [innerHtml]="text | safeHtml"></h2>
            </div>
            <div [ngStyle]="{'text-align': textAlignment?textAlignment:'center'}" *ngIf="buttonText"
              [attr.data-aos]="buttonAnimation ? buttonAnimation : null">
              <ng-container *ngIf="buttonLink && buttonLink.includes('#') && buttonLink.length<5; else externalLink">
                <button *ngIf="buttonText && buttonsDisplay!=0"
                  [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)',
                'background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}"
                  class="app-button mat-raised-button first-button" mat-raised-button=""
                  [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                  (click)='dePayWidgetsId ? openPay() : navigateTo(buttonLink)' rel="noopener" tabindex="0" aria-disabled="false">
                  <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                    {{buttonIcon?buttonIcon:'check_circle'}}</mat-icon>
                  <span class="mat-button-wrapper"> {{ buttonText }} </span>
                </button>
                <!-- <a *ngIf="buttonText && buttonsDisplay!=0" class="app-button mat-raised-button first-button" mat-raised-button="" (click)='navigateTo(buttonLink)' rel="noopener"  tabindex="0" aria-disabled="false">
                  <span class="mat-button-wrapper"> {{ buttonText }} </span>
                </a> -->
              </ng-container>
              <ng-template #externalLink>
                <a *ngIf="buttonText && buttonsDisplay!=0" class="app-button mat-raised-button first-button"
                  mat-raised-button=""
                  [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}"
                  [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}" rel="noopener"
                  tabindex="0" aria-disabled="false" [href]="buttonLink | safeUrl" [target]="'_blank'">
                  <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                    {{buttonIcon?buttonIcon:'check_circle'}}</mat-icon>
                  <span class="mat-button-wrapper"> {{ buttonText }} </span>
                </a>
              </ng-template>
              <span *ngIf="secondButtonText && buttonsDisplay==2">
                <ng-container *ngIf="buttonLink && buttonLink.includes('#') && buttonLink.length<5; else externalLink">
                  <a *ngIf="buttonText && buttonsDisplay!=0" class="app-button mat-raised-button second-button"
                    [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}"
                    [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                    mat-raised-button="" mat-raised-button="" (click)='navigateTo(secondButtonLink)' rel="noopener"
                    tabindex="0" aria-disabled="false">
                    <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                      {{secondaryButtonIcon?secondaryButtonIcon:'check_circle'}}</mat-icon>
                    <span class="mat-button-wrapper"> {{ secondButtonText }} </span>
                  </a>
                </ng-container>
                <ng-template #externalLink>
                  <a *ngIf="buttonText && buttonsDisplay!=0" class="app-button mat-raised-button second-button"
                    [ngStyle]="{'border-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','background-color': buttonBackgroundColor?buttonBackgroundColor:'var(--accent)','color': buttonTextColor?buttonTextColor:'#ffffff'}"
                    [ngClass]="{'style2': buttonStyle == 'style2','style3': buttonStyle == 'style3'}"
                    mat-raised-button="" mat-raised-button="" rel="noopener" tabindex="0" aria-disabled="false"
                    [href]="secondButtonLink | safeUrl" [target]="'_blank'">
                    <mat-icon *ngIf="buttonStyle == 'style2'" class="button-icon-style2">
                      {{secondaryButtonIcon?secondaryButtonIcon:'check_circle'}}</mat-icon>
                    <span class="mat-button-wrapper"> {{ secondButtonText }} </span>
                  </a>
                </ng-template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>
<style *ngIf="buttonStyle == 'style3' || buttonStyle == 'style2'">
  .style3:hover {
    color: var(--button-color-hero-video) !important;
    background-color: var(--button-background-hero-video) !important;
  }

  .style2:hover {
    color: var(--button-color-hero-video) !important;
    background-color: var(--button-background-hero-video) !important;
  }
</style>